"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var routes = [];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
exports.AppRoutingModule = AppRoutingModule;



// WEBPACK FOOTER //
// /home/travis/build/Pedro-vk/Bet-Token-wallet/src/app/app-routing.module.ts.pre-build-optimizer.js